export default {
	data() {
		return {
			_waitTimeout: null
		}
	},
	computed: {
		waiting() {
			return this.$data._waitTimeout !== null
		}
	},
	methods: {
		wait(ms) {
			// Cancel existing wait and set new one
			this.cancelWait()
			return new Promise(resolve => {
				this.$data._waitTimeout = window.setTimeout(() => {
					this.$data._waitTimeout = null
					resolve()
				}, ms)
			})
		},
		cancelWait() {
			window.clearTimeout(this.$data._waitTimeout)
			this.$data._waitTimeout = null
		}
	},
	beforeDestroy() {
		this.cancelWait()
	}
}
